import type { RouteRecordRaw } from 'vue-router';
import { ROLES } from '@AuthModule';

export default <RouteRecordRaw[]>[
  {
    path: 'products-and-services',
    name: 'products-and-services',
    component: () => import('./views/ProductsAndServices.view.vue'),
    meta: {
      permissions: [ROLES.PRODUCTS_AND_SERVICES],
    },
  },
];
